import { KpiWidgetComponent } from "./common/kpi-widget/kpi-widget.component";
import { LocationWidgetComponent } from "./common/location-widget/location-widget.component";
import { DcfGrowthRateInflationIndexWidgetComponent } from "./OneReport/dcf-growth-rate-inflation-index-widget/dcf-growth-rate-inflation-index-widget.component";
import { InspectionWidgetComponent } from "./OneReport/inspection-widget/inspection-widget.component";
import { AppendixWidgetComponent } from "./OneReport/appendix-widget/appendix-widget.component";
import { BudgetedCapexWidgetComponent } from "./OneReport/budgeted-capex-widget/budgeted-capex-widget.component";
import { CapitalExpenditureWidgetComponent } from "./OneReport/capital-expenditure-widget/capital-expenditure-widget.component";
import { CapitalExpendituresWidgetComponent } from "./OneReport/capital-expenditures-widget/capital-expenditures-widget.component";
import { ClientWidgetComponent } from "./OneReport/client-widget/client-widget.component";
import { RentKpiWidgetComponent } from "./OneReport/rent-kpi-widget/rent-kpi-widget.component";
import { CountrySpecificsWidgetComponent } from "./OneReport/country-specifics-widget/country-specifics-widget.component";
import { EsgCriteriaWidgetComponent } from "./OneReport/esg-criteria-widget/esg-criteria-widget.component";
import { EsgExteriorDescriptionWidgetComponent } from "./OneReport/esg-exterior-description-widget/esg-exterior-description-widget.component";
import { EsgInteriorDescriptionWidgetComponent } from "./OneReport/esg-interior-description-widget/esg-interior-description-widget.component";
import { FrontpageWidgetComponent } from "./OneReport/frontpage-widget/frontpage-widget.component";
import { HCashFlowWidgetComponent } from "./OneReport/h-cash-flow-widget/h-cash-flow-widget.component";
import { HRentRollWidgetComponent } from "./OneReport/hrentroll-widget/hrentroll-widget.component";
import { IncomeAnalysisWidgetComponent } from "./OneReport/income-analysis-widget/income-analysis-widget.component";
import { InvestmentComparablesWidgetComponent } from "./OneReport/investment-comparables-widget/investment-comparables-widget.component";
import { KeyFiguresWidgetComponent } from "./OneReport/key-figures-widget/key-figures-widget.component";
import { KeyTenantsWidgetComponent } from "./OneReport/key-tenants-widget/key-tenants-widget.component";
import { LeaseholdWidgetComponent } from "./OneReport/leasehold-widget/leasehold-widget.component";
import { LeasingComparablesWidgetComponent } from "./OneReport/leasing-comparables-widget/leasing-comparables-widget.component";
import { LocalMarketDataWidgetComponent } from "./OneReport/local-market-data-widget/local-market-data-widget.component";
import { MacroeconomicIndicatorsWidgetComponent } from "./OneReport/macroeconomic-indicators-widget/macroeconomic-indicators-widget.component";
import { MarketCapitalizationApproachWidgetComponent } from "./OneReport/market-capitalization-approach-widget/market-capitalization-approach-widget.component";
import { NonRecoverableCostsWidgetComponent } from "./OneReport/nonrecoverablecosts-widget/nonrecoverablecosts-widget.component";
import { PictureWidgetComponent } from "./OneReport/picture-widget/picture-widget.component";
import { PropertyAnalysisWidgetComponent } from "./OneReport/property-analysis-widget/property-analysis-widget.component";
import { PropertyDetailsWidgetComponent } from "./OneReport/property-details-widget/property-details-widget.component";
import { SiteInformationWidgetComponent } from "./OneReport/site-information-widget/site-information-widget.component";
import { SwotWidgetComponent } from "./OneReport/swot-widget/swot-widget.component";
import { TenantCovenantsWidgetComponent } from "./OneReport/tenant-covenants-widget/tenant-covenants-widget.component";
import { TenureWidgetComponent } from "./OneReport/tenure-widget/tenure-widget.component";
import { TextWidgetComponent } from "./OneReport/text-widget/text-widget.component";
import { TownPlanningWidgetComponent } from "./OneReport/town-planning-widget/town-planning-widget.component";
import { PropertyRatingWidgetComponent } from "./OneReport/property-rating-widget/property-rating-widget.component";
import { TableDummies1FullWidgetComponent } from "./OneReport/table-dummies1-full-widget/table-dummies1-full-widget.component";
import { TableDummies2FullWidgetComponent } from "./OneReport/table-dummies2-full-widget/table-dummies2-full-widget.component";
import { TableDummies3FullWidgetComponent } from "./OneReport/table-dummies3-full-widget/table-dummies3-full-widget.component";
import { TableDummies4FullWidgetComponent } from "./OneReport/table-dummies4-full-widget/table-dummies4-full-widget.component";
import { TableDummies1HalfWidgetComponent } from "./OneReport/table-dummies1-half-widget/table-dummies1-half-widget.component";
import { TableDummies2HalfWidgetComponent } from "./OneReport/table-dummies2-half-widget/table-dummies2-half-widget.component";
import { TableDummies3HalfWidgetComponent } from "./OneReport/table-dummies3-half-widget/table-dummies3-half-widget.component";
import { TableDummies4HalfWidgetComponent } from "./OneReport/table-dummies4-half-widget/table-dummies4-half-widget.component";
import { ValuationAssumptionsWidgetComponent } from "./OneReport/valuation-assumptions-widget/valuation-assumptions-widget.component";
import { ValuationDetailsWidgetComponent } from "./OneReport/valuation-details-widget/valuation-details-widget.component";
import { ValuationResultsWidgetComponent } from "./OneReport/valuation-results-widget/valuation-results-widget.component";
import { ValuationResults2WidgetComponent } from "./OneReport/valuation-results2-widget/valuation-results2-widget.component";
import { ValuationResults3WidgetComponent } from "./OneReport/valuation-results3-widget/valuation-results3-widget.component";
import { ValuationSummaryWidgetComponent } from "./OneReport/valuation-summary-widget/valuation-summary-widget.component";
import { PortfolioLettableAreaWidgetComponent } from "./portfolio/portfolio-lettable-area-widget/portfolio-lettable-area-widget.component";
import { PortfolioMarketValueWidgetComponent } from "./portfolio/portfolio-market-value-widget/portfolio-market-value-widget.component";
import { PortfolioNetRentWidgetComponent } from "./portfolio/portfolio-net-rent-widget/portfolio-net-rent-widget.component";
import { PortfolioPropertyListWidgetComponent } from "./portfolio/portfolio-property-list-widget/portfolio-property-list-widget.component";
import { ContractualRentComponent } from "./properties/contractual-rent/contractual-rent.component";
import { LeaseExpiryWidgetComponent } from "./properties/lease-expiry-widget/lease-expiry-widget.component";
import { LettableAreaWidgetComponent } from "./properties/lettable-area-widget/lettable-area-widget.component";
import { PropertyRentrollWidgetComponent } from "./properties/property-rentroll-widget/property-rentroll-widget.component";
import { PropertyValuationUnitWidgetComponent } from "./properties/property-valuation-unit-widget/property-valuation-unit-widget.component";
import { FranceEsgExteriorDescriptionWidgetComponent } from "./France/esg-exterior-description-widget/france-esg-exterior-description-widget.component";
import { FranceInvestmentComparablesWidgetComponent } from "./France/investment-comparables-widget/france-investment-comparables-widget.component";
import { FranceKeyFiguresWidgetComponent } from "./France/key-figures-widget/france-key-figures-widget.component";
import { FrancePropertyAnalysisWidgetComponent } from "./France/property-analysis-widget/france-property-analysis-widget.component";
import { FranceSiteInformationWidgetComponent } from "./France/site-information-widget/france-site-information-widget.component";
import { FranceTenureWidgetComponent } from "./France/tenure-widget/france-tenure-widget.component";
import { ContractSummaryWidgetComponent } from "./OneReport/contract-summary-widget/contract-summary-widget.component";
import { LandRegistryTenureWidgetComponent } from "./OneReport/land-registry-tenure-widget/land-registry-tenure-widget.component";
import { OverallCashFlowAssumptionsWidgetComponent } from "./OneReport/overall-cash-flow-assumptions-widget/overall-cash-flow-assumptions-widget.component";
import { EsgInteriorDescriptionLogisticsWidgetComponent } from "./OneReport/esg-interior-description-logistics-widget/esg-interior-description-logistics-widget.component";
import { EsgInteriorDescriptionRetailWidgetComponent } from "./OneReport/esg-interior-description-retail-widget/esg-interior-description-retail-widget.component";
import { ReportSummaryWidgetComponent } from "./OneReport/report-summary-widget/report-summary-widget.component";
import { CoverPageWidgetComponent } from "./OneReport/cover-page-widget/cover-page-widget.component";
import { GrossMarketRentToNetMarketRentWidgetComponent } from "./OneReport/gross-market-rent-to-net-market-rent-widget/gross-market-rent-to-net-market-rent-widget.component";
import { GrossRentToNoiWidgetComponent } from "./OneReport/gross-rent-to-noi-widget/gross-rent-to-noi-widget.component";
import { IncomeAnalysis2WidgetComponent } from "./OneReport/income-analysis2-widget/income-analysis2-widget.component";
import { ValuationResultsHardcoreTopSliceWidgetComponent } from "./OneReport/valuation-results-hardcore-topslice-widget/valuation-results-hardcore-topslice-widget.component";
import { LocalMarketDataInvestmentWidgetComponent } from "./OneReport/local-market-data-investment-widget/local-market-data-investment-widget.component";
import { IncomeExitBalanceOfIrrWidgetComponent } from "./OneReport/income-exit-balance-of-irr-widget/income-exit-balance-of-irr-widget.component";
import { CapitalExpenditureBreakdownWidgetComponent } from "./OneReport/capital-expenditure-breakdown-widget/capital-expenditure-breakdown-widget.component";
import { GrossRentToYear1NoiWidgetComponent } from "./OneReport/gross-rent-to-year-1-noi-widget/gross-rent-to-year-1-noi-widget.component";
import { EstimatedRentalValueWidgetComponent } from "./OneReport/estimated-rental-value-widget/estimated-rental-value-widget.component";
import { ServiceChargeNonRecoverablesWidgetComponent } from "./OneReport/service-charge-non-recoverables-widget/service-charge-non-recoverables-widget.component";
import { LettingAssumptionsWidgetComponent } from "./OneReport/letting-assumptions-widget/letting-assumptions-widget.component";
import { GeneralPricingAssumptionsWidgetComponent } from "./OneReport/general-pricing-assumptions-widget/general-pricing-assumptions-widget.component";
import { MacroLocationFiguresWidgetComponent } from "./OneReport/macro-location-figures-widget/macro-location-figures-widget.component";
import { AppendixPageWidgetComponent } from "./OneReport/appendix-page-widget/appendix-page-widget.component";
import { SocioEconomicDataWidgetComponent } from "./OneReport/socio-economic-data-widget/socio-economic-data-widget.component";
import { CalculationOfThePotentialExitValueWidgetComponent } from "./OneReport/calculation-of-the-potential-exit-value-widget/calculation-of-the-potential-exit-value-widget.component";
import { ValuationResultsResidualWidgetComponent } from "./OneReport/valuation-results-residual-widget/valuation-results-residual-widget.component";
import { CapitalExpenditureCalculationOfDevelopmentCostsWidgetComponent } from "./OneReport/capital-expenditure-calculation-of-development-costs-widget/capital-expenditure-calculation-of-development-costs-widget.component";
import { HardcoreTopsliceWidgetComponent } from "./OneReport/hardcore-topslice-widget/hardcore-topslice-widget.component";
import { SensitivityAnalysisWidgetComponent } from "./OneReport/sensitivity-analysis-widget/sensitivity-analysis-widget.component";
import { EsgWidgetComponent } from "./OneReport/esg-widget/esg-widget.component";
import { CountrySpecificsHighestAndBestUseWidgetComponent } from "./OneReport/country-specifics-highest-and-best-use-widget/country-specifics-highest-and-best-use-widget.component";
import { ClientIntendedUseAndUserWidgetComponent } from "./US/client-intended-use-and-user-widget/client-intended-use-and-user-widget.component";
import { OwnershipAndTransactionHistoryWidgetComponent } from "./OneReport/ownership-and-transaction-history-widget/ownership-and-transaction-history-widget.component";
import { SignatureWidgetComponent } from "./US/signature-widget/signature-widget.component";
import { LicenseWidgetComponent } from "./US/license-widget/license-widget.component";
import { FullLineWidgetComponent } from "./common/full-line-widget/full-line-widget.component";
import { MainSectionTitleWidgetComponent } from "./common/main-section-title-widget/main-section-title-widget.component";
import { DcfGeneralAssumptionsComponent } from "./OneReport/dcf-general-assumptions/dcf-general-assumptions.component";
import { DcfAssumptionsWidgetComponent } from "./OneReport/dcf-assumptions-widget/dcf-assumptions-widget.component";
import { DcfLeasingAndRenewalAssumptionsWidgetComponent } from "./OneReport/dcf-leasing-and-renewal-assumptions-widget/dcf-leasing-and-renewal-assumptions-widget.component";
import { PeriodOverPeriodWidgetComponent } from "./OneReport/period-over-period-widget/period-over-period-widget.component";
import { TableDummyFullWidgetComponent } from "./OneReport/table-dummy-full-widget/table-dummy-full-widget.component";
import { TableDummyHalfWidgetComponent } from "./OneReport/table-dummy-half-widget/table-dummy-half-widget.component";
import { ValueConclusionTableWidgetComponent } from "./OneReport/value-conclusion-table-widget/value-conclusion-table-widget.component";
import { LeaseComparablesSummaryWidgetComponent } from "./US/lease-comparables-summary-widget/lease-comparables-summary-widget.component";
import { DirectCapLeaseExpirationComponent } from "./US/direct-cap-lease-expiration-widget/direct-cap-lease-expiration-widget.component";
import { DirectCapConclusionComponent } from "./US/direct-cap-conclusion-widget/direct-cap-conclusion-widget.component";
import { MarketLeasingAssumptionsWidgetComponent } from "./US/market-leasing-assumptions-widget/market-leasing-assumptions-widget.component";
import { CapRateCalculationsComponent } from "./US/cap-rate-calculations-widget/cap-rate-calculations-widget.component";
import { LeaseSummaryWidgetComponent } from "./US/lease-summary-widget/lease-summary-widget.component";
import { TenantRolloverWidgetComponent } from "./US/tenant-rollover-widget/tenant-rollover-widget.component";
import { NoiProjectionWidgetComponent } from "./US/noi-projection-widget/noi-projection-widget.component";
import { DirectCapPgiOccupiedSpaceWidgetComponent } from "./US/direct-cap-pgi-occupied-space-widget/direct-cap-pgi-occupied-space-widget.component";
import { DirectCapPgiVacantSpaceWidgetComponent } from "./US/direct-cap-pgi-vacant-space-widget/direct-cap-pgi-vacant-space-widget.component";
import { DirectCapPgiSummaryWidgetComponent } from "./US/direct-cap-pgi-summary-widget/direct-cap-pgi-summary-widget.component";
import { MiscRevenueWidgetComponent } from "./US/misc-revenue-widget/misc-revenue-widget.component";
import { EffectiveGrossIncomeComponent } from "./US/effective-gross-income-widget/effective-gross-income-widget.component";
import { HistoryAndProjectionsComponent } from "./US/history-and-projections/history-and-projections-widget.component";
import { ExpertSurveyWidgetComponent } from "./US/expert-survey-widget/expert-survey-widget.component";
import { DirectCapExpenseCompsWidgetComponent } from "./US/direct-cap-expense-comps-widget/direct-cap-expense-comps-widget.component";
import { InvestorSurveysWidgetComponent } from "./US/investor-surveys-widget/investor-surveys-widget.component";
import { CapRateCompsWidgetComponent } from "./US/cap-rate-comps-widget/cap-rate-comps-widget.component";
import { CapRateReconciliationWidgetComponent } from "./US/cap-rate-reconciliation-widget/cap-rate-reconciliation-widget.component";
import { DirectCapHRentRollWidgetComponent } from "./US/direct-cap-hrentroll-widget/direct-cap-hrentroll-widget.component";
import { LeaseUpCostsWidgetComponent } from "./US/lease-up-costs-widget/lease-up-costs-widget.component";
import { ImprovedSalesMapWidgetComponent } from "./US/improved-sales-map-widget/improved-sales-map-widget.component";
import { ImprovedSalesSummaryWidgetComponent } from "./US/improved-sales-summary-widget/improved-sales-summary-widget.component";
import { DirectCapLeaseCompsMapWidgetComponent } from "./US/direct-cap-lease-comps-map-widget/direct-cap-lease-comps-map-widget.component";
import { SalesGridWidgetComponent } from "./US/sales-grid-widget/sales-grid-widget.component";
import { SalesApproachValuationWidgetComponent } from "./US/sales-approach-valuation-widget/sales-approach-valuation-widget.component";

/**
 * When developing a new widget, please register it in this array, first.
 * The downgradedName is the component name in AngularJs notation. In AngularJS HTML, the component name is each capital letter to lower case, prefixed by a '-'. Example:
 *
  {
    downgradedName: 'nonRecoverableCostsWidget',
    componentClass: NonRecoverableCostsWidgetComponent
  },
 * This registers the NonRecoverableCostsWidgetComponent as a widget. It will add it to the report designer module and also add it as an entryComponent there.
 * In AngularJs, the component name is 'nonRecoverableCostsWidget' and it can be added in ANgularJs HTML as '<non-recoverable-costs-widget [parameters etc...]><non-recoverable-costs-widget>/'
 * 
 * Then, please register it in the ValuationWidgetsLx JSON file.
 */
export const reportDesignerWigdets = [
  {
    downgradedName: 'propertyValuationUnitWidget',
    dataverseName: 'TODO',
    componentClass: PropertyValuationUnitWidgetComponent
  },
  {
    downgradedName: 'propertyRentrollWidget',
    dataverseName: 'TODO',
    componentClass: PropertyRentrollWidgetComponent
  },
  {
    downgradedName: 'contractualRent',
    dataverseName: 'TODO',
    componentClass: ContractualRentComponent
  },
  {
    downgradedName: 'lettableAreaWidget',
    dataverseName: 'TODO',
    componentClass: LettableAreaWidgetComponent
  },
  {
    downgradedName: 'leaseExpiryWidget',
    dataverseName: 'TODO',
    componentClass: LeaseExpiryWidgetComponent
  },
  {
    downgradedName: 'locationWidget',
    dataverseName: 'TODO',
    componentClass: LocationWidgetComponent
  },
  {
    downgradedName: 'portfolioMarketValueWidget',
    dataverseName: 'TODO',
    componentClass: PortfolioMarketValueWidgetComponent
  },
  {
    downgradedName: 'portfolioLettableAreaWidget',
    dataverseName: 'TODO',
    componentClass: PortfolioLettableAreaWidgetComponent
  },
  {
    downgradedName: 'portfolioNetRentWidget',
    dataverseName: 'TODO',
    componentClass: PortfolioNetRentWidgetComponent
  },
 {
   downgradedName: 'kpiWidget',
   dataverseName: 'TODO',
    componentClass: KpiWidgetComponent
  },
  {
    downgradedName: 'textWidget',
    dataverseName: 'WidgetText',
    componentClass: TextWidgetComponent
  },
  {
    downgradedName: 'portfolioPropertyListWidget',
    dataverseName: 'TODO',
    componentClass: PortfolioPropertyListWidgetComponent
  },
  {
    downgradedName: 'valuationAssumptionsWidget',
    dataverseName: 'WidgetValuationAssumptions',
    componentClass: ValuationAssumptionsWidgetComponent
  },
  {
    downgradedName: 'tenureWidget',
    dataverseName: 'WidgetTenure',
    componentClass: TenureWidgetComponent
  },
  {
    downgradedName: 'nonRecoverableCostsWidget',
    dataverseName: 'WidgetNonRecoverableCosts',
    componentClass: NonRecoverableCostsWidgetComponent
  },
  {
    downgradedName: 'townPlanningWidget',
    dataverseName: 'WidgetTownPlanning',
    componentClass: TownPlanningWidgetComponent
  },
  {
    downgradedName: 'siteInformationWidget',
    dataverseName: 'WidgetSiteInformation',
    componentClass: SiteInformationWidgetComponent
  },
  {
    downgradedName: 'swotWidget',
    dataverseName: 'WidgetSwot',
    componentClass: SwotWidgetComponent
  },
  {
    downgradedName: 'frontpageWidget',
    dataverseName: 'WidgetFrontpage',
    componentClass: FrontpageWidgetComponent
  },
  {
    downgradedName: 'keyFiguresWidget',
    dataverseName: 'WidgetKeyFigures',
    componentClass: KeyFiguresWidgetComponent
  },
  {
    downgradedName: 'localMarketDataWidget',
    dataverseName: 'WidgetLocalMarketData',
    componentClass: LocalMarketDataWidgetComponent
  },
  {
    downgradedName: 'propertyAnalysisWidget',
    dataverseName: 'WidgetPropertyAnalysis',
    componentClass: PropertyAnalysisWidgetComponent
  },
  {
    downgradedName: 'valuationResultsWidget',
    dataverseName: 'WidgetValuationResults',
    componentClass: ValuationResultsWidgetComponent
  },
  {
    downgradedName: 'hrentrollWidget',
    dataverseName: 'WidgetHRentRoll',
    componentClass: HRentRollWidgetComponent
  },
  {
    downgradedName: 'hCashFlowWidget',
    dataverseName: 'WidgetHCashFlow',
    componentClass: HCashFlowWidgetComponent
  },
  {
    downgradedName: 'macroeconomicIndicatorsWidget',
    dataverseName: 'WidgetMacroeconomicIndicators',
    componentClass: MacroeconomicIndicatorsWidgetComponent
  },
  {
    downgradedName: 'dcfGeneralAssumptions',
    dataverseName: 'WidgetDCFGeneralAssumptions',
    componentClass: DcfGeneralAssumptionsComponent
  },
  {
    downgradedName: 'dcfAssumptionsWidget',
    dataverseName: 'WidgetDCFAssumptions',
    componentClass: DcfAssumptionsWidgetComponent
  },
  {
    downgradedName: 'dcfGrowthRateInflationIndexWidget',
    dataverseName: 'WidgetDcfGrowthRateInflationIndex',
    componentClass: DcfGrowthRateInflationIndexWidgetComponent
  },
  {
    downgradedName: 'rentKpiWidget',
    dataverseName: 'WidgetRentKpi',
    componentClass: RentKpiWidgetComponent
  },
  {
    downgradedName: 'pictureWidget',
    dataverseName: 'WidgetPicture',
    componentClass: PictureWidgetComponent
  },
  {
    downgradedName: 'investmentComparablesWidget',
    dataverseName: 'WidgetInvestmentComparables',
    componentClass: InvestmentComparablesWidgetComponent
  },
  {
    downgradedName: 'propertyDetailsWidget',
    dataverseName: 'WidgetPropertyDetails',
    componentClass: PropertyDetailsWidgetComponent
  },
  {
    downgradedName: 'valuationDetailsWidget',
    dataverseName: 'TODO',
    componentClass: ValuationDetailsWidgetComponent
  },
  {
    downgradedName: 'dcfLeasingAndRenewalAssumptionsWidget',
    dataverseName: 'TODO',
    componentClass: DcfLeasingAndRenewalAssumptionsWidgetComponent
  },
  {
    downgradedName: 'inspectionWidget',
    dataverseName: 'TODO',
    componentClass: InspectionWidgetComponent
  },
  {
    downgradedName: 'budgetedCapexWidget',
    dataverseName: 'TODO',
    componentClass: BudgetedCapexWidgetComponent
  },
  {
    downgradedName: 'appendixWidget',
    dataverseName: 'WidgetAppendix',
    componentClass: AppendixWidgetComponent
  },
  {
    downgradedName: 'keyTenantsWidget',
    dataverseName: 'WidgetKeyTenants',
    componentClass: KeyTenantsWidgetComponent
  },
  {
    downgradedName: 'esgInteriorDescriptionWidget',
    dataverseName: 'WidgetEsgInteriorDescription',
    componentClass: EsgInteriorDescriptionWidgetComponent
  },
  {
    downgradedName: 'esgExteriorDescriptionWidget',
    dataverseName: 'WidgetEsgExteriorDescription',
    componentClass: EsgExteriorDescriptionWidgetComponent
  },
  {
    downgradedName: 'valuationSummaryWidget',
    dataverseName: 'WidgetValuationSummary',
    componentClass: ValuationSummaryWidgetComponent
  },
  {
    downgradedName: 'esgCriteriaWidget',
    dataverseName: 'WidgetEsgCriteria',
    componentClass: EsgCriteriaWidgetComponent
  },
  {
    downgradedName: 'tenantCovenantsWidget',
    dataverseName: 'WidgetTenantCovenants',
    componentClass: TenantCovenantsWidgetComponent
  },
  {
    downgradedName: 'capitalExpenditureWidget',
    dataverseName: 'WidgetCapitalExpenditure',
    componentClass: CapitalExpenditureWidgetComponent
  },
  {
    downgradedName: 'capitalExpendituresWidget',
    dataverseName: 'WidgetCapitalExpenditure',
    componentClass: CapitalExpendituresWidgetComponent
  },
  {
    downgradedName: 'incomeAnalysisWidget',
    dataverseName: 'WidgetIncomeAnalysis',
    componentClass: IncomeAnalysisWidgetComponent
  },
  {
    downgradedName: 'clientWidget',
    dataverseName: 'WidgetClient',
    componentClass: ClientWidgetComponent
  },
  {
    downgradedName: 'marketCapitalizationApproachWidget',
    dataverseName: 'WidgetMarketCapitalizationApproach',
    componentClass: MarketCapitalizationApproachWidgetComponent
  },
  {
    downgradedName: 'leaseholdWidget',
    dataverseName: 'WidgetLeasehold',
    componentClass: LeaseholdWidgetComponent
  },
  {
    downgradedName: 'leasingComparablesWidget',
    dataverseName: 'WidgetLeasingComparables',
    componentClass: LeasingComparablesWidgetComponent
  },
  {
    downgradedName: 'lettingAssumptionsWidget',
    dataverseName: 'WidgetLettingAssumptions',
    componentClass: LettingAssumptionsWidgetComponent
  },
  {
    downgradedName: 'valuationResults2Widget',
    dataverseName: 'TODO',
    componentClass: ValuationResults2WidgetComponent
  },
  {
    downgradedName: 'valuationResults3Widget',
    dataverseName: 'WidgetValuationResults3',
    componentClass: ValuationResults3WidgetComponent
  },
  {
    downgradedName: 'franceEsgExteriorDescriptionWidget',
    dataverseName: 'TODO',
    componentClass: FranceEsgExteriorDescriptionWidgetComponent
  },
  {
    downgradedName: 'franceInvestmentComparablesWidget',
    dataverseName: 'TODO',
    componentClass: FranceInvestmentComparablesWidgetComponent
  },
  {
    downgradedName: 'francePropertyAnalysisWidget',
    dataverseName: 'TODO',
    componentClass: FrancePropertyAnalysisWidgetComponent
  },
  {
    downgradedName: 'franceTenureWidget',
    dataverseName: 'TODO',
    componentClass: FranceTenureWidgetComponent
  },
  {
    downgradedName: 'countrySpecificsWidget',
    dataverseName: 'WidgetCountrySpecifics',
    componentClass: CountrySpecificsWidgetComponent
  },
  {
    downgradedName: 'countrySpecificsHighestAndBestUseWidget',
    dataverseName: 'WidgetCountrySpecificsHighestAndBestUse',
    componentClass: CountrySpecificsHighestAndBestUseWidgetComponent
  },
  {
    downgradedName: 'ownershipAndTransactionHistoryWidget',
    dataverseName: 'WidgetOwnershipAndTransactionHistory',
    componentClass: OwnershipAndTransactionHistoryWidgetComponent
  },
  {
    downgradedName: 'franceKeyFiguresWidget',
    dataverseName: 'TODO',
    componentClass: FranceKeyFiguresWidgetComponent
  },
  {
    downgradedName: 'franceSiteInformationWidget',
    dataverseName: 'TODO',
    componentClass: FranceSiteInformationWidgetComponent
  },
  {
    downgradedName: 'contractSummaryWidget',
    dataverseName: 'WidgetContractSummary',
    componentClass: ContractSummaryWidgetComponent
  },
  {
    downgradedName: 'landRegistryTenureWidget',
    dataverseName: 'WidgetLandRegistryTenure',
    componentClass: LandRegistryTenureWidgetComponent
  },
  {
    downgradedName: 'overallCashFlowAssumptionsWidget',
    dataverseName: 'WidgetOverallCashFlowAssumptions',
    componentClass: OverallCashFlowAssumptionsWidgetComponent
  },
  {
    downgradedName: 'esgInteriorDescriptionLogisticsWidget',
    dataverseName: 'WidgetEsgInteriorDescriptionLogistics',
    componentClass: EsgInteriorDescriptionLogisticsWidgetComponent
  },
  {
    downgradedName: 'esgInteriorDescriptionRetailWidget',
    dataverseName: 'WidgetEsgInteriorDescriptionRetail',
    componentClass: EsgInteriorDescriptionRetailWidgetComponent
  },
  {
    downgradedName: 'reportSummaryWidget',
    dataverseName: 'WidgetReportSummary',
    componentClass: ReportSummaryWidgetComponent
  },
  {
    downgradedName: 'coverPageWidget',
    dataverseName: 'WidgetCoverPage',
    componentClass: CoverPageWidgetComponent
  },
  {
    downgradedName: 'grossMarketRentToNetMarketRentWidget',
    dataverseName: 'WidgetGrossMarketRentToNetMarketRent',
    componentClass: GrossMarketRentToNetMarketRentWidgetComponent
  },
  {
    downgradedName: 'grossRentToNoiWidget',
    dataverseName: 'WidgetGrossRentToNoi',
    componentClass: GrossRentToNoiWidgetComponent
  },
  {
    downgradedName: 'incomeAnalysis2Widget',
    dataverseName: 'WidgetIncomeAnalysis2',
    componentClass: IncomeAnalysis2WidgetComponent
  },
  {
    downgradedName: 'valuationResultsHardcoreTopSliceWidget',
    dataverseName: 'WidgetValuationResultsHardcoreTopSlice',
    componentClass: ValuationResultsHardcoreTopSliceWidgetComponent
  },
  {
    downgradedName: 'localMarketDataInvestmentWidget',
    dataverseName: 'WidgetLocalMarketDataInvestment',
    componentClass: LocalMarketDataInvestmentWidgetComponent
  },
  {
    downgradedName: 'incomeExitBalanceOfIrrWidget',
    dataverseName: 'WidgetIncomeExitBalanceOfIrr',
    componentClass: IncomeExitBalanceOfIrrWidgetComponent
  },
  {
    downgradedName: 'capitalExpenditureBreakdownWidget',
    dataverseName: 'WidgetCapitalExpenditureBreakdown',
    componentClass: CapitalExpenditureBreakdownWidgetComponent
  },
  {
    downgradedName: 'grossRentToYear1NoiWidget',
    dataverseName: 'WidgetGrossRentToYear1Noi',
    componentClass: GrossRentToYear1NoiWidgetComponent
  },
  {
    downgradedName: 'estimatedRentalValueWidget',
    dataverseName: 'WidgetEstimatedRentalValue',
    componentClass: EstimatedRentalValueWidgetComponent
  },
  {
    downgradedName: 'serviceChargeNonRecoverablesWidget',
    dataverseName: 'WidgetServiceChargeNonRecoverables',
    componentClass: ServiceChargeNonRecoverablesWidgetComponent
  },
  {
    downgradedName: 'generalPricingAssumptionsWidget',
    dataverseName: 'WidgetGeneralPricingAssumptions',
    componentClass: GeneralPricingAssumptionsWidgetComponent
  },
  {
    downgradedName: 'macroLocationFiguresWidget',
    dataverseName: 'WidgetMacroLocationFigures',
    componentClass: MacroLocationFiguresWidgetComponent
  },
  {
    downgradedName: 'appendixPageWidget',
    dataverseName: 'TODO',
    componentClass: AppendixPageWidgetComponent
  },
  {
    downgradedName: 'socioEconomicDataWidget',
    dataverseName: 'WidgetSocioEconomicData',
    componentClass: SocioEconomicDataWidgetComponent
  },
  {
    downgradedName: 'calculationOfThePotentialExitValueWidget',
    dataverseName: 'TODO',
    componentClass: CalculationOfThePotentialExitValueWidgetComponent
  },
  {
    downgradedName: 'valuationResultsResidualWidget',
    dataverseName: 'WidgetResidualValueCalculation',
    componentClass: ValuationResultsResidualWidgetComponent
  },
  {
    downgradedName: 'capitalExpenditureCalculationOfDevelopmentCostsWidget',
    dataverseName: 'TODO',
    componentClass: CapitalExpenditureCalculationOfDevelopmentCostsWidgetComponent
  },
  {
    downgradedName: 'hardcoreTopsliceWidget',
    dataverseName: 'WidgetHardcoreTopSlice',
    componentClass: HardcoreTopsliceWidgetComponent
  },
  {
    downgradedName: 'sensitivityAnalysisWidget',
    dataverseName: 'WidgetSensitivityAnalysis',
    componentClass: SensitivityAnalysisWidgetComponent
  },
  {
    downgradedName: 'esgWidget',
    dataverseName: 'WidgetEsg',
    componentClass: EsgWidgetComponent
  },
  {
    downgradedName: 'propertyRatingWidget',
    dataverseName: 'WidgetPropertyRating',
    componentClass: PropertyRatingWidgetComponent
  },
  {
    downgradedName: 'tableDummies1FullWidget',
    dataverseName: 'WidgetTableDummies1Full',
    componentClass: TableDummies1FullWidgetComponent
  },
  {
    downgradedName: 'tableDummies2FullWidget',
    dataverseName: 'TODO',
    componentClass: TableDummies2FullWidgetComponent
  },
  {
    downgradedName: 'tableDummies3FullWidget',
    dataverseName: 'TODO',
    componentClass: TableDummies3FullWidgetComponent
  },
  {
    downgradedName: 'tableDummies4FullWidget',
    dataverseName: 'TODO',
    componentClass: TableDummies4FullWidgetComponent
  },
  {
    downgradedName: 'tableDummies1HalfWidget',
    dataverseName: 'WidgetTableDummies1Half',
    componentClass: TableDummies1HalfWidgetComponent
  },
  {
    downgradedName: 'tableDummies2HalfWidget',
    dataverseName: 'TODO',
    componentClass: TableDummies2HalfWidgetComponent
  },
  {
    downgradedName: 'tableDummies3HalfWidget',
    dataverseName: 'TODO',
    componentClass: TableDummies3HalfWidgetComponent
  },
  {
    downgradedName: 'tableDummies4HalfWidget',
    dataverseName: 'TODO',
    componentClass: TableDummies4HalfWidgetComponent
  },
  {
    downgradedName: 'clientIntendedUseAndUserWidget',
    dataverseName: 'WidgetClientIntendedUseAndUser',
    componentClass: ClientIntendedUseAndUserWidgetComponent
  },
  {
    downgradedName: 'signatureWidget',
    dataverseName: 'TODO',
    componentClass: SignatureWidgetComponent
  },
  {
    downgradedName: 'licenseWidget',
    dataverseName: 'TODO',
    componentClass: LicenseWidgetComponent
  },
  {
    downgradedName: 'widgetFullLine',
    dataverseName: 'TODO',
    componentClass: FullLineWidgetComponent
  },
  {
    downgradedName: 'widgetMainSectionTitle',
    dataverseName: 'TODO',
    componentClass: MainSectionTitleWidgetComponent
  },
  {
    downgradedName: 'periodOverPeriodWidget',
    dataverseName: 'WidgetPeriodOverPeriod',
    componentClass: PeriodOverPeriodWidgetComponent
  },
  {
    downgradedName: 'tableDummyFullWidget',
    dataverseName: 'WidgetTableDummyFull',
    componentClass: TableDummyFullWidgetComponent
  },
  {
    downgradedName: 'tableDummyHalfWidget',
    dataverseName: 'WidgetTableDummyHalf',
    componentClass: TableDummyHalfWidgetComponent
  },
  {
    downgradedName: 'valueConclusionTableWidget',
    dataverseName: 'WidgetValueConclusionTable',
    componentClass: ValueConclusionTableWidgetComponent
  },
  {
    downgradedName: 'leaseComparablesSummaryWidget',
    dataverseName: 'TODO',
    componentClass: LeaseComparablesSummaryWidgetComponent
  },
  {
    downgradedName: 'directCapLeaseExpirationWidget',
    dataverseName: 'TODO',
    componentClass: DirectCapLeaseExpirationComponent
  },
  {
    downgradedName: 'directCapConclusionWidget',
    dataverseName: 'TODO',
    componentClass: DirectCapConclusionComponent
  },
  {
    downgradedName: 'marketLeasingAssumptionsWidget',
    dataverseName: 'TODO',
    componentClass: MarketLeasingAssumptionsWidgetComponent
  },
  {
    downgradedName: "capRateCalculationsWidget",
    dataverseName: 'todo',
    componentClass: CapRateCalculationsComponent
  },
  {
    downgradedName: 'leaseSummaryWidget',
    dataverseName: 'TODO',
    componentClass: LeaseSummaryWidgetComponent
  },
  {
    downgradedName: 'tenantRolloverWidget',
    dataverseName: 'TODO',
    componentClass: TenantRolloverWidgetComponent
  },
  {
    downgradedName: 'noiProjectionWidget',
    dataverseName: 'TODO',
    componentClass: NoiProjectionWidgetComponent
  },
  {
    downgradedName: 'directCapPGIOccupiedSpaceWidget',
    dataverseName: 'TODO',
    componentClass: DirectCapPgiOccupiedSpaceWidgetComponent
  },
  {
    downgradedName: 'directCapPGIVacantSpaceWidget',
    dataverseName: 'TODO',
    componentClass: DirectCapPgiVacantSpaceWidgetComponent
  },
  {
    downgradedName: 'directCapPGISummaryWidget',
    dataverseName: 'TODO',
    componentClass: DirectCapPgiSummaryWidgetComponent
  },
  {
    downgradedName: 'miscRevenueWidget',
    dataverseName: 'TODO',
    componentClass: MiscRevenueWidgetComponent
  },
  {
    downgradedName: 'effectiveGrossIncomeWidget',
    dataverseName: 'TODO',
    componentClass: EffectiveGrossIncomeComponent
  },
  {
    downgradedName: 'historyAndProjectionsWidget',
    dataverseName: 'TODO',
    componentClass: HistoryAndProjectionsComponent
  },
  {
    downgradedName: 'expertSurveyWidget',
    dataverseName: 'TODO',
    componentClass: ExpertSurveyWidgetComponent
  },
  {
    downgradedName: 'directCapExpenseCompsWidget',
    dataverseName: 'TODO',
    componentClass: DirectCapExpenseCompsWidgetComponent
  },
  {
    downgradedName: 'investorSurveysWidget',
    dataverseName: 'TODO',
    componentClass: InvestorSurveysWidgetComponent
  },
  {
    downgradedName: "capRateCompsWidget",
    dataverseName: 'TODO',
    componentClass: CapRateCompsWidgetComponent
  },
  {
    downgradedName: 'capRateReconciliationWidget',
    dataverseName: 'TODO',
    componentClass: CapRateReconciliationWidgetComponent
  },
  {
    downgradedName: 'directCapHrentrollWidget',
    dataverseName: 'TODO',
    componentClass: DirectCapHRentRollWidgetComponent
  },
  {
    downgradedName: 'leaseUpCostsWidget',
    dataverseName: 'TODO',
    componentClass: LeaseUpCostsWidgetComponent
  },
  {
    downgradedName: 'improvedSalesMapWidget',
    dataverseName: 'TODO',
    componentClass: ImprovedSalesMapWidgetComponent
  },
  {
    downgradedName: 'directCapLeaseCompsMapWidget',
    dataverseName: 'TODO',
    componentClass: DirectCapLeaseCompsMapWidgetComponent
  },
  {
    downgradedName: 'improvedSalesSummaryWidget',
    dataverseName: 'TODO',
    componentClass: ImprovedSalesSummaryWidgetComponent
  },
  {
    downgradedName: 'salesGridWidget',
    dataverseName: 'TODO',
    componentClass: SalesGridWidgetComponent
  },
  {
    downgradedName: 'SalesApproachValuationWidget',
    dataverseName: 'TODO',
    componentClass: SalesApproachValuationWidgetComponent
  }
];
